export enum CDataD365Edition {
    HumanResources = 0,
    CustomerService = 1,
    Marketing = 2,
    FieldService = 3,
    ProjectOperations = 4,
    FinOpsOnline = 5,
    Sales = 6,
    FinOpsOnPremise = 7
}